export const WELCOME_MESSAGE_CREATE = 'message_create';
export const WELCOME_MESSAGE_EDIT = 'message_edit';
export const WELCOME_MESSAGE_VIEW = 'message_view';

export const DEVICE_OPTIONS = [
  { id: 'Tablet', name: 'Tablet' },
  { id: 'TV', name: 'TV' },
];

export const AUDIENCE_OPTIONS = [
  { id: 'Rooms', name: 'Rooms' },
  { id: 'Room Type', name: 'Room Type' },
  { id: 'Floors', name: 'Floors' },
  { id: 'Block Code', name: 'Block Code' },
  { id: 'Loyalty Tier', name: 'Loyalty Tier' },
];

export const MOCK_BLOCK_CODES = [
  { id: 'BLK001', name: 'Block Code 1' },
  { id: 'BLK002', name: 'Block Code 2' },
  { id: 'BLK003', name: 'Block Code 3' },
];

export const MOCK_LOYALTY_TIERS = [
  { id: 'TIER001', name: 'Gold' },
  { id: 'TIER002', name: 'Silver' },
  { id: 'TIER003', name: 'Platinum' },
  { id: 'TIER004', name: 'Diamond' },
];

export const HEADING_SIZES = {
  1: 32,
  2: 28,
  3: 24,
  4: 20,
};
